var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"orders-order"},[_vm._v(" "+_vm._s(_vm.before)+" "+_vm._s(_vm.text != null ? _vm.text : '--')+" "+_vm._s(_vm.after)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }